import { jsx } from 'react/jsx-runtime';
import { CircleLoaderContainer, SkeletonLoaderAnimation } from './SkeletonCircleLoader.styles.mjs';
"use strict";
const SkeletonCircleLoader = function SkeletonCircleLoader2({
  diameter = 20,
  className
}) {
  return /* @__PURE__ */jsx(CircleLoaderContainer, {
    $diameter: diameter,
    className,
    children: /* @__PURE__ */jsx(SkeletonLoaderAnimation, {})
  });
};
export { SkeletonCircleLoader };
//# sourceMappingURL=SkeletonCircleLoader.mjs.map
